import { createAsyncThunk } from '@reduxjs/toolkit';
import { generateRequest } from 'services/secureDataSharing';
import { IGenerateRequestPayload } from 'services/secureDataSharing/types';
import { ICommonResponse } from 'services/types';

export const ThunkGenerateRequest = createAsyncThunk<
  ICommonResponse<string>,
  IGenerateRequestPayload
>('secureDataSharing/generateRequest', payload => generateRequest(payload).then(r => r.data));
